export default __webpack_public_path__ + "static/char-v-38-ja-4ea67d112f9cf898769eb81f66832e77.mp4";